/**
 * Mock card checkout for local Quasar dev only (not deployed dev/prod builds).
 */
export const localMockCardFlowToolsEnabled = !!import.meta.env.QUASAR_DEV

export const MOCK_CARD_FLOW_STORAGE_KEY = 'blu.dev.mockCardFlow'

export const MOCK_CARD_FLOW_REQUEST_HEADER = 'X-Blu-Mock-Card-Flow'
